module.exports = __webpack_public_path__ + "img/im_scrollfeature_11.aac318b0.jpg";